
// CookieInformation.js
import React, { useEffect }  from 'react';
import CookieList from './CookieList';
import CookieButton from './CookieButton';
import DOMPurify from 'dompurify';


const CookieInformation = ({ cookieInformationHeadline = 'Cookies', cookieInformationSubheadline = '', cookieInformationText = '', cookieButtonLabel = ''}) => {

	useEffect(() => {
		window.applicationReInit(['CookieHandler']);
	}, []);
	
	return (
		<>
			<div className="l-grid l-grid--max-width">
				<div className="l-grid__row">
					<div className="l-grid__column-12">
						<p className="c-copy"></p>
						<h1 className="c-heading  c-heading--page c-heading--page c-stage__headline c-link--capitalize u-text-center">
							{cookieInformationHeadline}
						</h1>
					</div>
				</div>
			</div>

			<div className="l-grid l-grid--max-width c-component-header u-margin-top-xl u-margin-bottom-m">
				<div className="l-grid__row">
					<div className="l-grid__column-medium-10 offset-medium-1 c-component-header__headline-wrapper">
							<div className="c-heading--section__container js-enable-infopoints c-headline__item">
								<h3 className="c-heading  c-heading--section u-text-center c-component-header__headline c-link--capitalize ">
									{cookieInformationSubheadline}
								</h3>
							</div>
					</div>
					<div className="offset-large-1 offset-medium-1 l-grid__column-large-10 l-grid__column-medium-10">
						<div className="c-copy c-component-header__copytext  ">
							<div className="c-copy"
								dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cookieInformationText) }}>
							</div>

							<div style={{width: '100%', height: '40px'}}></div>

							<CookieButton cookieButtonLabel={cookieButtonLabel} />
							<div className="divider parbase">
								{/* eslint-disable-next-line */}
								<hr className="c-divider " role="none" aria-hidden="true" />
							</div>
							<CookieList />
						</div>
					</div>
				</div>
			</div>
		</>
	)
};

export default CookieInformation;



